import React from 'react';
import { usePetForm } from '../PetFormContext/PetFormContext';
import { CLINIC_NAME_MAX_DISPLAY_LENGTH } from '../../../api/constant';
import { Clinic } from './vetClinicResponse';
import VetFailureSnackbar from './VetFailureSnackbar';
import VetActionableSnackbar from './VetActionableSnackbar';
import { undoText } from './vetContent';

const VetSnackbars = ({
  handleUndoRemoveClinic,
}: {
  handleUndoRemoveClinic: (clinic: Clinic) => void;
}) => {
  const {
    selectedRemoveClinic,
    setSelectedUndoRemoveClinic,
    displayAssignErrorSnackbar,
    setDisplayAssignErrorSnackbar,
    displayCreateErrorSnackbar,
    setDisplayCreateErrorSnackbar,
    displayUnassignErrorSnackbar,
    setDisplayUnassignErrorSnackbar,
    setShowAddVetSheet,
    showUndoSnackbar,
    setShowUndoSnackbar,
  } = usePetForm();

  const getShortenedName = (clinic: Clinic) =>
    clinic.name.length > CLINIC_NAME_MAX_DISPLAY_LENGTH
      ? clinic.name.slice(0, CLINIC_NAME_MAX_DISPLAY_LENGTH) + '...'
      : clinic.name;

  return (
    <>
      {showUndoSnackbar && (
        <VetActionableSnackbar
          visible={showUndoSnackbar}
          actionMessage={`We removed ${getShortenedName(selectedRemoveClinic)}`}
          buttonText={undoText}
          onClick={() => {
            handleUndoRemoveClinic(selectedRemoveClinic);
            setSelectedUndoRemoveClinic(true);
            setShowUndoSnackbar(false);
          }}
          onClose={() => {
            setShowUndoSnackbar(false);
          }}
        />
      )}
      {displayUnassignErrorSnackbar && (
        <VetFailureSnackbar
          visible={displayUnassignErrorSnackbar}
          setVisibility={setDisplayUnassignErrorSnackbar}
          message={`We were unable to remove ${getShortenedName(
            selectedRemoveClinic,
          )} from your vet clinics`}
        />
      )}
      {displayAssignErrorSnackbar && (
        <VetActionableSnackbar
          visible={displayAssignErrorSnackbar}
          actionMessage="We were unable to save your vet clinic"
          buttonText="Try Again"
          onClick={() => {
            setDisplayAssignErrorSnackbar(false);
            setShowAddVetSheet(true);
          }}
          onClose={() => {
            setDisplayAssignErrorSnackbar(false);
          }}
        />
      )}
      {displayCreateErrorSnackbar && (
        <VetFailureSnackbar
          visible={displayCreateErrorSnackbar}
          setVisibility={setDisplayCreateErrorSnackbar}
          message="Failed to add new clinic. Try again later."
        />
      )}
    </>
  );
};

export default VetSnackbars;
